import { render, staticRenderFns } from "./DashboardSignInfo.vue?vue&type=template&id=084df027&scoped=true"
import script from "./DashboardSignInfo.vue?vue&type=script&lang=js"
export * from "./DashboardSignInfo.vue?vue&type=script&lang=js"
import style0 from "./DashboardSignInfo.vue?vue&type=style&index=0&id=084df027&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084df027",
  null
  
)

export default component.exports